
import React, { useState } from 'react';
import { Session, User } from '@supabase/supabase-js';
import { AuthContext } from './AuthContext';

export const MockAuthProvider = ({ children }: { children: React.ReactNode }) => {
    // Hardcoded Trial User
    const [user] = useState<User | null>({
        id: 'trial-user',
        aud: 'authenticated',
        role: 'authenticated',
        email: 'guest@dotting.space',
        email_confirmed_at: new Date().toISOString(),
        phone: '',
        confirmed_at: new Date().toISOString(),
        last_sign_in_at: new Date().toISOString(),
        app_metadata: {
            provider: 'email',
            providers: ['email'],
        },
        user_metadata: {},
        identities: [],
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
    });

    const [profile] = useState<any | null>({
        id: 'trial-user',
        full_name: 'Guest Architect',
        email: 'guest@dotting.space',
        role: 'pro', // Give them Pro access to try features
        credits: 100, // Enough for trial
        is_active: true,
        subscription_tier: 'pro',
        subscription_status: 'active',
        subscription_expires_at: new Date(Date.now() + 86400000).toISOString() // Expires in 24 hours
    });

    // Mock Session
    const [session] = useState<Session | null>({
        access_token: 'mock-token',
        token_type: 'bearer',
        expires_in: 3600,
        refresh_token: 'mock-refresh-token',
        user: user!,
    });

    const [loading] = useState(false);

    const signOut = async () => {
        console.log("Mock Sign Out - In a real app, this would redirect.");
        // Maybe redirect to /login or refresh the trial? 
        // For now, doing nothing is safe, or we can reload the page.
        window.location.href = '/';
    };

    const refreshProfile = async () => {
        console.log("Mock Refresh Profile");
        // No-op for trial
    };

    return (
        <AuthContext.Provider value={{ session, user, profile, loading, signOut, refreshProfile }}>
            {children}
        </AuthContext.Provider>
    );
};
